import React from 'react';
import AuthorParcelsTable from './authorParcelsTableNew';
import CarrierParcelsTable from './carrierParcelsTable.jsx';
import { getRoles } from '../../../services/userRights';
import { recordUserActivityIfNeeded } from '../../../services/userActivity';

export default class ParcelsTable extends React.Component {
    componentDidMount() {
        recordUserActivityIfNeeded();
    }

    render() {
        let isCarrier = getRoles().includes('Carrier');
        return isCarrier 
			? <CarrierParcelsTable history={this.props.history} /> 
			: <AuthorParcelsTable history={this.props.history} />;
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/table/parcelsTableNew.jsx